exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/phoneinfo2/phoneinfo/src/app/components/latest-device/latest-device.component.css
// module id = ../../../../../src/app/components/latest-device/latest-device.component.css
// module chunks = main